import { useState } from 'react';
import { useRoles } from '../hooks/useRoles';
import { useDebounce } from '@/shared/hooks/useDebounce';
import { CreateRoleDialog } from '../components/CreateRoleDialog';
import { RolesTable } from '../components/RolesTable';
import { LoadingAnimation } from '@/shared/components/LoadingAnimation';

export const RoleManagement = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const debouncedSearch = useDebounce(searchTerm, 300);

  const { data: rolesPage, isLoading, error } = useRoles(currentPage, pageSize, debouncedSearch.trim() || undefined);

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load roles</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Role Management</h1>
          <p className="text-gray-500 mt-1">
            Manage system roles and permissions
          </p>
        </div>
        <CreateRoleDialog />
      </div>

      <RolesTable
        roles={rolesPage?.items ?? []}
        searchTerm={searchTerm}
        onSearchTermChange={(term) => { setSearchTerm(term); setCurrentPage(1); }}
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={rolesPage?.totalCount ?? 0}
        totalPages={rolesPage?.totalPages ?? 1}
        onPageChange={setCurrentPage}
        onPageSizeChange={(size) => { setPageSize(size); setCurrentPage(1); }}
      />
    </div>
  );
};